<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
  <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>

<div class="contentBox" (window:resize)="onResize()">
  <div class="center col-3">
    <div class="info-logo-container">
      <img src="{{ info.logo }}" class="payment_method_no_interactive" alt="{{ info.name }}"/>
    </div>
  </div>
  <div *ngIf="!viewResultQR" class="col-7">
    <div class="methodInfo">
      <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
      </app-return-methods>
      <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
      <br>
      <p>{{ 'title-QR' | translation | async }}</p>
      <br>
      <mat-card-content>
        <form name="userData" id="userData" autocomplete="off">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'forms-Full-Name' | translation | async }}</mat-label>
            <input
              #fullName
              type="text"
              name="fullName"
              matInput [formControl]="fullNameControl"
              [(ngModel)]="qrFormModel.fullName"
              (keyup)="enableButton()"
              placeholder="{{ 'forms-Full-Name' | translation | async }}"/>
            <mat-hint align="end">{{fullName.value?.length || 0}}/50</mat-hint>
            <mat-error *ngIf="fullNameControl.hasError('pattern')">
              {{ 'form-specialCharacter' | translation | async }}
            </mat-error>
            <mat-error *ngIf="fullNameControl.hasError('required')">
              {{ 'forms-required-field' | translation | async }}
            </mat-error>
            <mat-error *ngIf="fullNameControl.hasError('maxlength')">
              {{ 'forms-maxLength' | translation | async }}
            </mat-error>
          </mat-form-field>
          <br>
          <br>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'forms-TypeDoc-Input' | translation | async }}</mat-label>
            <mat-select [(ngModel)]="qrFormModel.documentType" (selectionChange)="enableButton()" required>
              <mat-option [value]="document['VALUE']" *ngFor="let document of listOfDocuments">
                {{document['TEXT']}}</mat-option>
            </mat-select>
          </mat-form-field>
          <br>
          <br>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'forms-NumDoc-Input' | translation | async }}</mat-label>
            <input
              #documentNumber
              type="text"
              name="documentNumber"
              [(ngModel)]="qrFormModel.documentNumber"
              matInput [formControl]="documentNumberControl"
              (keyup)="enableButton()"
              placeholder="{{ 'forms-NumDoc-Input' | translation | async }}"/>
            <mat-hint align="end">{{documentNumber.value?.length || 0}}/20</mat-hint>
            <mat-error *ngIf="!(documentNumberControl.hasError(''))">
              {{ 'form-invalid-document-number' | translation | async }}
            </mat-error>
          </mat-form-field>
          <br>
          <br>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'forms-NumCel-Input' | translation | async }}</mat-label>
            <input
              #numCel
              type="text"
              name="numCel"
              [(ngModel)]="qrFormModel.cellphone"
              matInput [formControl]="numCelControl"
              (keyup)="enableButton()"
              placeholder="{{ 'forms-NumCel-Input' | translation | async }}"/>
            <mat-hint align="end">{{numCel.value?.length || 0}}/20</mat-hint>
            <mat-error *ngIf="!(numCelControl.hasError(''))">
              {{ 'form-invalid-cell-number' | translation | async }}
            </mat-error>
          </mat-form-field>
          <br>
          <br>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
            <input
              #email
              type="email"
              name="email"
              [(ngModel)]="qrFormModel.email"
              matInput [formControl]="emailControl"
              (keyup)="enableButton()"
              placeholder="{{ 'forms-Email-Input' | translation | async }}"/>
            <mat-hint align="end">{{email.value?.length || 0}}/100</mat-hint>
            <mat-error *ngIf="!(emailControl.hasError(''))">
              {{ 'forms-EmailInvalid' | translation | async }}
            </mat-error>
          </mat-form-field>
        </form>
      </mat-card-content>
      <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
    </div>
    <button class="button"
            mat-flat-button
            color="primary"
            [disabled]="!completedForms()"
            (click)="sendData()">
    {{ 'generated-QR' | translation | async  }}
    </button>
  </div>

  <div *ngIf="viewResultQR" class="col-7">
    <div class="methodInfo">
      <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
      </app-return-methods>
      <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
      <br>
      <br>
      <mat-card-content class="card">
        <br>
        <p *ngIf="!isMobileDevice" class="title-help-qr">  {{ 'title-help-qr' | translation | async  }}</p>

        <div *ngIf="isMobileDevice">
          <h3 class="title-help-qr">{{ 'title-movil-help-qr' | translation | async  }}</h3>
          <p class="title-help-qr"><b>1.</b> {{ 'title-movil-help-one' | translation | async  }} </p>
          <p class="title-help-qr"><b>2.</b> {{ 'title-movil-help-two' | translation | async  }} </p>
        </div>
        <img class="img-qr" [src]="imagenQR | safe" alt="QR"/>
      </mat-card-content>

    </div>
  </div>


</div>
